import axios from "./axios";
import { userData } from "./Currentuserdata";

export default {
  /**
   * Get All Customers
   * @api {Get} managecustomer
   */
  getClasses(data) {
    const user = userData();
    const options = {
      method: "GET",
      url: "customersTypes/classes",
      headers: { "content-type": "application/json" },
      params: {
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  getClassesHistory(data) {
    const user = userData();
    const options = {
      method: "GET",
      url: "customersTypes/classes/history",
      headers: { "content-type": "application/json" },
      params: {
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  getClassesFiltered(data) {
    const user = userData();
    const options = {
      method: "GET",
      url: "customersTypes/classes/filtered",
      headers: { "content-type": "application/json" },
      params: {
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  createData(data) {
    const options = {
      method: "POST",
      url: 'customersTypes/importDataTypes',
      headers: {'content-type': 'application/json'},
      data: data
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  createClass(data) {
    const user = userData();
    const options = {
      method: "POST",
      url: 'customersTypes/classes',
      headers: {'content-type': 'application/json'},
      data:{
        name:data,
        ID_Branch: user.branch,
        ID_Business: user.businessid,
      }
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  createCat(data) {
    const user = userData();
    const options = {
      method: "POST",
      url: `customersTypes/categories`,
      headers: {'content-type': 'application/json'},
      data:{
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data 
      }
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  createSub(data) {
    const user = userData();
    const options = {
      method: "POST",
      url: `customersTypes/sub`,
      headers: {'content-type': 'application/json'},
      data:{
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data
      }
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.messageageage);
        });
    });
  },

  getOneFam(id) {
    const user = userData();
    const options = {
      method: "GET",
      url: `customersTypes/getonefam/${id}`,
      headers: {'content-type': 'application/json'},
      data: {
        ID_Branch: user.branch,
        ID_Business: user.businessid        ,
      }
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
updateFam(data){
  const user = userData();
  const options = {
    method: "PUT",
    url: `customersTypes/fam/${data.id}`,
    headers: {'content-type': 'application/json'},
    data:{
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      name:data.name
    }
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });

},
deleteClass(id){
  const user = userData();
  const options = {
    method: "DELETE",
    url: `customersTypes/classes/${id}`,
    headers: {'content-type': 'application/json'},
    data: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
    }
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });

},
/* end customersTypes Classes */

getCategories(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "customersTypes/categories",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},
getCategoriesByClass( data ) {
  const options = {
    method: "GET",
    url: "customersTypes/classgetcats",
    headers: { "content-type": "application/json" },
    params: {
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log( error );
        reject(error.message);
      });
  });
},
getCategoriesHistory(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "customersTypes/categories/history",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getCategoriesFiltered(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "customersTypes/categories/filtered",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getOneCat(id) {
  const user = userData();
  const options = {
    method: "GET",
    url: `customersTypes/getonecat/${id}`,
    headers: {'content-type': 'application/json'},
    data: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
    }
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},
updateCat(data){
const user = userData();
const options = {
  method: "PUT",
  url: `customersTypes/categories/${data.id}`,
  headers: {'content-type': 'application/json'},
  data:{
    ID_Branch: user.branch,
    ID_Business: user.businessid        ,
    ...data
  }
};
return new Promise((resolve, reject) => {
  axios(options)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.message);
    });
});

},
deleteCat(id){
const user = userData();
const options = {
  method: "DELETE",
  url: `customersTypes/categories/${id}`,
  headers: {'content-type': 'application/json'},
  data: {
    ID_Branch: user.branch,
    ID_Business: user.businessid        ,
  },
};
return new Promise((resolve, reject) => {
  axios(options)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.message);
    });
});

},
/* end customersTypes categories */

getSubs(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "customersTypes/getallsub",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},
getSubsByCategory(data) {
  const options = {
    method: "GET",
    url: "customersTypes/catgetsubs",
    headers: { "content-type": "application/json" },
    params: {
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getSubsHistory(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "customersTypes/sub/history",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getSubsFiltered(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "customersTypes/getallsub/list/filtered",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getOneSub(id) {
  const user = userData();
  const options = {
    method: "GET",
    url: `customersTypes/getonesub/${id}`,
    headers: {'content-type': 'application/json'},
    data: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},
updateSub(data){
const user = userData();
const options = {
  method: "PUT",
  url: `customersTypes/sub/${data.id}`,
  headers: {'content-type': 'application/json'},
  data:{
    ID_Branch: user.branch,
    ID_Business: user.businessid        ,
    ...data
  }
};
return new Promise((resolve, reject) => {
  axios(options)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.message);
    });
});

},
deleteSub(id){
const user = userData();
const options = {
  method: "DELETE",
  url: `customersTypes/sub/${id}`,
  headers: {'content-type': 'application/json'},
  data: {
    ID_Branch: user.branch,
    ID_Business: user.businessid        ,
  },
};
return new Promise((resolve, reject) => {
  axios(options)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.message);
    });
});

},
/* end customersTypes subcategories */

  getBrands(data) {
    const options = {
      method: "GET",
      url: "customersTypes/getBrands",
      headers: { "content-type": "application/json" },
      params: {
        ...data
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },

  addBrand(data) {
    const options = {
      method: "POST",
      url: "customersTypes/addBrand",
      headers: { "content-type": "application/json" },
      data: data
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },

  deleteBrand(data) {
    const options = {
      method: "POST",
      url: "customersTypes/deleteBrand",
      headers: { "content-type": "application/json" },
      data: data
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  
  // Métodos de paginación para carga virtual
  findAllClassesPaginated(data = {}) {
    const user = userData();
    const options = {
      method: "GET",
      url: "customersTypes/getallfam/paginated",
      headers: { 
        "content-type": "application/json",
        "id_business": user.businessid
      },
      params: {
        page: data.page || 1,
        limit: data.limit || 20,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },

  findCategoriesByFamilyPaginated(familyId, data = {}) {
    const user = userData();
    const options = {
      method: "GET",
      url: "customersTypes/getallcat/findByFamilyPaginated",
      headers: { 
        "content-type": "application/json",
        "id_business": user.businessid
      },
      params: {
        id_family: familyId,
        page: data.page || 1,
        limit: data.limit || 20,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log('findCategoriesByFamilyPaginated - error:', error);
          reject(error.message);
        });
    });
  },

  findSubcategoriesByCategoryPaginated(categoryId, data = {}) {
    const user = userData();
    const options = {
      method: "GET",
      url: "customersTypes/getallsub/findByCategoryPaginated",
      headers: { 
        "content-type": "application/json",
        "id_business": user.businessid,
        "id_branch": user.branch
      },
      params: {
        id_cat: categoryId,
        page: data.page || 1,
        limit: data.limit || 20,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log('findSubcategoriesByCategoryPaginated - error:', error);
          reject(error.message);
        });
    });
  },
};
